import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const TvBrandingComponent = lazy(
  () => import('../pages/tv-branding/tv-branding.tsx')
);
const TabletBrandingComponent = lazy(
  () => import('../pages/tablet-branding/tablet-branding.tsx')
);
const MobileBrandingComponent = lazy(
  () => import('../pages/mobile-branding/mobile-branding.tsx')
);

/**
 * Public web/iframe child routes. TV branding is the index element directly
 * (no redirect) so the `?mode=web` query is never dropped by an internal
 * <Navigate>. Tablet and mobile are explicit child paths; the tab switcher
 * navigates to `${basePath}/${tab}` and preserves the `?mode=web` query.
 */
export const appBuilderWebRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <Suspense>
        <TvBrandingComponent />
      </Suspense>
    )
  },
  {
    path: 'tv-branding',
    element: (
      <Suspense>
        <TvBrandingComponent />
      </Suspense>
    )
  },
  {
    path: 'tablet-branding',
    element: (
      <Suspense>
        <TabletBrandingComponent />
      </Suspense>
    )
  },
  {
    path: 'mobile-branding',
    element: (
      <Suspense>
        <MobileBrandingComponent />
      </Suspense>
    )
  }
];
